import { Instagram } from "lucide-react";
import { Kicker, Reveal } from "../components/Reveal";
import { BUSINESS } from "../lib/data";
import { IG_POSTS } from "../lib/serviceContent";

export default function InstagramSection() {
  return (
    <section id="instagram" data-testid="instagram-section" className="border-t border-linen bg-ivory py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <Reveal className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <Kicker>On Instagram</Kicker>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
              Follow along
            </h2>
          </div>
          <a
            href={BUSINESS.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-follow-button"
            className="inline-flex w-fit items-center gap-2.5 rounded-md border border-linen px-6 py-3 text-sm font-semibold text-forest transition-colors duration-300 hover:border-forest"
          >
            <Instagram size={16} /> {BUSINESS.instagram}
          </a>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {IG_POSTS.map((post, i) => (
            <Reveal key={post.id} delay={i * 0.03}>
              <a
                href={BUSINESS.instagramUrl}
                target="_blank"
                rel="noreferrer"
                data-testid={`instagram-post-${post.id}`}
                className="group relative block aspect-square overflow-hidden rounded-md"
              >
                <img src={post.url} alt={post.alt} loading="lazy" className="h-full w-full object-cover transition-opacity duration-300 group-hover:opacity-85" />
                <span className="absolute inset-0 flex items-center justify-center bg-forest/0 transition-colors duration-300 group-hover:bg-forest/30">
                  <Instagram size={22} className="text-ivory opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
